import { cfetch } from '@confluence/network';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */
const getAutomationDevStackFromLocalServer = async () => {
	try {
		const devStackResponse = await cfetch('https://localhost:8082/devStack.json', {
			method: 'GET',
			headers: {
				Accept: 'application/json',
			},
			credentials: 'omit', // omit credentials to avoid CORS issues. This is a local stack check only and we don't need credentials.
		});
		const devStack = await devStackResponse.json();
		return devStack.name;
	} catch (e) {
		// eslint-disable-next-line no-console
		console.warn(
			`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`,
		);
		return null;
	}
};

/**
 * Get the automation stack to use for the current environment. This checks both the local server (devWatch) or local storage to see if we should use a dev stack.
 * If not, we will use staging if the Confluence env is STAGING, otherwise we will use the default prod automation stack.
 * @param environment
 */
export const getAutomationStack = async (environment: string) => {
	switch (environment) {
		case 'DEVELOPMENT':
		case 'STAGING':
			return (
				(await getAutomationDevStackFromLocalServer()) ||
				window.localStorage.getItem(keys.AUTOMATION_PLATFORM_STACK) ||
				'staging'
			);
		default: // For production, use the default automation stack
			return 'pro';
	}
};
